/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-no-undef */
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
} from '@material-ui/core';
import React from 'react';

export default function CreateEmail({
  isRTL,
  letterforms,
  setOpen,
  setOpenproc,
  setFormdoc,
}: any) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNew = () => {
    setOpenproc(true);
    setAnchorEl(null);
  };
  const handleFormSelect = (item: any) => {
    setFormdoc(item);
    setOpen(true);
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box>
      <Box style={{ height: 50 }}>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          style={{
            height: 44,
            marginTop: 24,
            marginLeft: 10,
            marginRight: 10,
            width: 180,
            borderRadius: 10,
          }}
          onClick={handleClick}
        >
          <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>
            {isRTL ? 'انشاء' : 'Compose'}
          </Typography>
        </Button>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{ style: { borderRadius: 10 } }}
      >
        <List style={{ minWidth: 200, paddingLeft: 10, paddingRight: 10 }}>
          <ListItem
            button
            onClick={handleNew}
            style={{ margin: 5, borderRadius: 7 }}
          >
            <ListItemText>
              <Typography>{isRTL ? 'رسالة جديدة' : 'New Email'}</Typography>
            </ListItemText>
          </ListItem>

          <Divider />
          {letterforms?.map((letter: any) => {
            return (
              <ListItem
                button
                onClick={() => handleFormSelect(letter)}
                style={{ margin: 5, borderRadius: 7 }}
              >
                <ListItemText>
                  <Typography>
                    {isRTL ? letter?.nameAr : letter?.name}
                  </Typography>
                </ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </Box>
  );
}
